exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-wrapper[data-v-6919a74c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}.image-wrapper img[data-v-6919a74c]{border:1px solid #ccc}.image-delete[data-v-6919a74c]{position:absolute;top:-5px;font-size:11px;border-radius:50%;left:22px;background-color:red;color:#fff;width:15px;height:15px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.img-preview[data-v-6919a74c]{width:34px;height:34px;-o-object-fit:cover;object-fit:cover;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6919a74c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/admin-panel/components/inputs/image.vue
// module id = TySw
// module chunks = 0